import { useMutation, useQueryClient } from '@tanstack/react-query';
import { configApi } from '../../configApi';

const deletePPPIQDocument = async (documentId: string): Promise<void> => {
  await configApi.delete(`registration/pppiq/${documentId}/`);
};

export const useDeletePPPIQDocument = (registrationId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (documentId: string) => deletePPPIQDocument(documentId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['pppiq_documents', registrationId] });
    },
  });
};
